import { Component, OnInit, Input } from '@angular/core'
import { TrainingStateGateway } from '../../gateways/training-state-gateway'
import { TrainingModel } from '../../models/training-model'
import { PortalGlobals } from '../../../../app/portalglobals' 
// import { ActivatedRoute } from '@angular/router'
import { Router, ActivatedRoute, Params } from '@angular/router'

@Component({
    selector: 'UserTraining',
    templateUrl: 'training-state-list.component.html'
})

export class TrainingStateListComponent implements OnInit {

    @Input() trainingheader: string
    userProfileID = 0
    mode = 'add'
    planyear = 0
    userCoursesViewModel: TrainingModel[]

    // Training Table nodata message to be displayed
    showcoursemsg = false
    showcourses = true


    constructor(
        private trainingStateGateway: TrainingStateGateway,
        private route: ActivatedRoute,
        private routers: Router,
        public _global: PortalGlobals) {
        // this.trainingStateGateway.GetUserTrainingDetails('2016', '14962', 'vpanda').subscribe(
        //    (userCoursesViewModel: TrainingModel[]) => this.userCoursesViewModel = userCoursesViewModel
        // )
        // this.route.queryParams.subscribe(params => {
        //    if (params['mode']) {
        //        this.mode = params['mode']
        //    }
        //    if (params['userprofileid']) {
        //        this.userProfileID = params['userprofileid']
        //    }
        //    if (params['planyear']) {
        //        this.planyear = params['planyear']
        //    }
        // })
        this.route.params.forEach((params: Params) => {
            if (params['mode']) {
                this.mode = params['mode']
            }
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']

            }

        })
        this.planyear = this._global.selectedPlanYear
        this.trainingStateGateway.GetUserTrainingDetails(this.userProfileID, this.planyear).subscribe(
           //  (userCoursesViewModel: TrainingModel[]) => this.userCoursesViewModel = userCoursesViewModel
            // region start - Training Table nodata message to be displayed 
            (userCoursesViewModel: TrainingModel[]) => {
                this.userCoursesViewModel = userCoursesViewModel
                this.showCourseDetails()
            }
        )
    }
     showCourseDetails(): void {
        if (this.userCoursesViewModel == null) {
          this.showcoursemsg = true
            this.showcourses = false
        }
     }
    // region end - Training Table nodata message to be displayed

    ngOnInit(): void {
        this.trainingheader = 'Training'
        // this.trainingStateGateway.GetUserTrainingDetails().subscribe(
        //    (model: TrainingModel[]) => {
        //        this.userCoursesViewModel = model
        //    }
        // )
    }
}
